import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  getAuth,
  setAuth,
} from "../../utils/helpers";

import {
  notification
} from '../actions';

export const getToken = createAsyncThunk("getToken", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.post(`/v1/authorization`, payload);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

//payload = { token: auth }
/*
export const varifyToken = verifyToken("verifyToken", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.post(`/v1/verify-token`, payload);
    if (response.status === 200 && response.data) {
      return response.data
    } else {
      console.log("response: ", response.data)
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})
*/

/*
payload = {
    username: email,
    refresh_token: auth
  }
*/
/*
export const refreshToken = refreshToken("refreshToken", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.post(`/v1/refresh-token`, payload);
    if (response.status === 200 && response.data) {
      return response.data
    } else {
      console.log("response: ", response.data)
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})
*/